<div class="col-xs-12 col-sm-12 myprofile_tabContent" id="myprofile_tabContent2" >

  <div class="col-xs-12 col-sm-12 no-padding myprofile_tabContentHeader">{{"ukprofile.myacctext" | cxTranslate}}</div>
  <div class="col-xs-12 col-sm-12 no-padding org_content">{{accountdata?.spCompanyName}}</div>


  <div class="col-xs-12 col-sm-12 no-padding ">

    <div class="row myprofile_row-flex myprofile_topsections myProfileForUK">

      @if (isSearchByProfile) {
        <div class="col-md-4 col-sm-12 col-xs-12  no-left-padding">
          <div class=" myprofile_acc ">
            <div class="account-header">{{"ukprofile.accinfotext" | cxTranslate}}</div>
            <div class="profileaccount-content">
              <div class="myprofile_hybrisheader">{{"ukprofile.accNumlabel" | cxTranslate}}</div>
              <div class="myprofile_hybrisheader_txt_sub">{{accountdata?.soldToAcc}}</div>
            </div>
            <div class="profileaccount-content">
              <div class="myprofile_hybrisheader">{{"ukprofile.emailabel" | cxTranslate}}</div>
              <div class="myprofile_hybrisheader_txt_sub">{{accountdata?.soldToEmail}}</div>
            </div>
            <div class="profileaccount-content">
              <div class="myprofile_hybrisheader">{{"ukprofile.phnlabel" | cxTranslate}}</div>
              <div class="myprofile_hybrisheader_txt_sub">{{accountdata?.soldToPh}}<span class="myprofile_hybrisheader_txt_sub">&nbsp;Ext.
              {{accountdata?.soldToExt}}</span>
            </div>
          </div>
        </div>
      </div>
    }
    <div class="col-md-8 col-sm-12 col-xs-12 myprofile_flex myProfile_myOrg no-right-padding">
      <div class="myprofileuk_content">
        <div class="myOrg_parent">
          <div class="col-md-9 col-sm-8 col-xs-8 no-left-padding">
            <div class="Org_header">{{"ukprofile.myorgtext" | cxTranslate}}</div>

          </div>

          <div class="col-md-3 col-sm-4 col-xs-4 no-right-padding">
            @if (accountrba?.currentUserAccountPermission=='MANAGE') {
              @if (accountdata?.status != 'PENDING' && !editview && showsubmitedit) {
                <div class="myprofile_edit" id="myprofile_editbtn" (click)="showedit()">
                  {{"profile.editlabel" | cxTranslate}} <img  src="assets/images/edit.png" width="20" alt="Edit">
                </div>
              }
            }
          </div>
        </div>
        @if (!editview) {
          <div class="myprofile_view">
            <div class="row margin-T20">
              <div class="col-md-4 col-sm-3 col-xs-5">
                <div class="myprofile_hybrisheader_sub_txt">{{"ukprofile.orgtypelabel" | cxTranslate}}</div>
                <div class="myprofile_hybrisheader_txt_sub">{{accountdata?.businessType}}</div>
              </div>
              <div class="col-md-4 col-sm-4 col-xs-5">
                <div class="myprofile_hybrisheader_sub_txt">{{"ukprofile.dellocslabel" | cxTranslate}}</div>
                <div class="myprofile_hybrisheader_txt_sub">{{accountdata?.countuk}}</div>
              </div>
              <div class="col-md-4 col-sm-5 col-xs-5 org_mob">
                <div class="myprofile_hybrisheader_sub_txt">{{"ukprofile.nhslabel" | cxTranslate}}</div>
                <div class="myprofile_hybrisheader_txt_sub">{{accountdata?.nhcNumber}}</div>
              </div>
            </div>
            <div class="row margin-T20">
              <div class="col-md-4 col-sm-3 col-xs-5">
                <div class="myprofile_hybrisheader_sub_txt">{{"ukprofile.vatlabel" | cxTranslate}}</div>
                <div class="myprofile_hybrisheader_txt_sub">{{accountdata?.vatNumber}}</div>
              </div>
              <div class="col-md-4 col-sm-4 col-xs-5 ukprofile_RegNo">
                <div class="myprofile_hybrisheader_sub_txt">{{"ukprofile.regnolabel" | cxTranslate}}</div>
                <div class="myprofile_hybrisheader_txt_sub">{{accountdata?.companyRegNumber}}</div>
              </div>
              <div class="col-md-4 col-sm-5 col-xs-5 org_mob">
                <div class="myprofile_hybrisheader_sub_txt">{{"ukprofile.tradesincelabel" | cxTranslate}}</div>
                <div class="myprofile_hybrisheader_txt_sub">{{accountdata?.tradingSince}}</div>
              </div>
            </div>
            <div class="row margin-T20">
              <div class="col-md-6 col-sm-6 col-xs-12 ">
                <div class="myprofile_hybrisheader_sub_txt">{{"ukprofile.addrlabel" | cxTranslate}}</div>
                <div class="myprofile_company_address">
                  @if (accountdata?.orgAddressLine1) {
                    {{accountdata?.orgAddressLine1}},<br>
                  }
                  @if (accountdata?.orgAddressLine2) {
                    {{accountdata?.orgAddressLine2}},<br>
                  }
                  {{accountdata?.orgAddressCity}},
                  {{accountdata?.orgAddressCountryName}}<br>
                {{accountdata?.orgAddressZipCode}}</div>
              </div>
              <div class="col-md-6 col-md-offset-3 col-sm-6 col-xs-12 org-add">
                <div class="myprofile_hybrisheader_sub_txt">{{"ukprofile.maincontactlabel" | cxTranslate}}</div>
                <div class="myprofile_company_contact">
                  {{accountdata?.customerDataLastName}}&nbsp;{{accountdata?.customerDataFirstName}}<br>
                  {{accountdata?.customerDataOrgAddressEmail}}<br>
                {{accountdata?.customerDataOrgAddressPhone}}&nbsp;Ext. {{accountdata?.customerDataOrgAddressPhoneExt}}</div>
              </div>
            </div>
          </div>
        }




        <!-- edit view  -->
        @if (editview) {
          <div class="myprofile_editview" >
            <div class="row">
              <div class="col-md-9 col-sm-12 col-xs-12 margin-T20">
                <div class="myprofile_editheader_txt ">{{"ukprofile.contactinfotitle" | cxTranslate}} &nbsp;&nbsp;&nbsp;<a
                  (click)="openrequestmodal()"
                  id="myprofile_request" data-bs-toggle="modal" data-bs-target="#requestform"><span class="myprofile_editheader_txt_sub">{{"accountinfo.reqchangestext" | cxTranslate}}<div class="global_blackarrow"></div></span></a>
                </div>
              </div>
            </div>
            <form  id="myprofile_editForm" [formGroup]="customerRegisterForm" method="post" novalidate="novalidate">
              <div class="row margin-T10">
                <div class="col-md-6 col-sm-6 col-xs-12">
                  <label class="myprofile_editcompany_txt editnameuk" for="Account-no">{{"ukprofile.orgnamelabel" | cxTranslate}}</label>
                  <input class="myprofile_input form-control" formControlName="Accountname" id="Account-no" name="Account-no" value="" >
                </div>
                <div class="col-md-6 col-sm-6 col-xs-12">
                  <label class="myprofile_editcompany_txt" for="company-name">{{"ukprofile.orgtypelabel" | cxTranslate}}</label>
                  <select class="myprofile_state form-control" id="company-type" name="companytype" formControlName="businessType" >
                    <option [value]="accountdata?.businessType">{{accountdata?.businessType}}</option>
                  </select>
                </div>
              </div>
              <div class="row margin-T10">
                <div class="col-md-3 col-sm-6 col-xs-12">
                  <label class="myprofile_editcompany_txt editnameuk" for="delivery_count">{{"ukprofile.dellocslabel" | cxTranslate}}</label> <input class="myprofile_input form-control" id="delivery_count" name="delivery_count" formControlName="countuk" value="" >
                </div>
                <div class="col-md-3 col-sm-6 col-xs-12">
                  <label class="myprofile_editcompany_txt editnameuk" for="nhs_code">{{"ukprofile.nhslabel" | cxTranslate}}</label> <input class="myprofile_input form-control" id="nhs_code" name="nhs_code" value=""  formControlName="nhcNumber">
                </div>
                <div class="col-md-3 col-sm-6 col-xs-12">
                  <label class="myprofile_editcompany_txt editnameuk" for="vat_no">{{"ukprofile.vatlabel" | cxTranslate}}</label> <input class="myprofile_input form-control" id="vat_no" name="vat_no" value=""  formControlName="vatNumber">
                </div>
                <div class="col-md-3 col-sm-6 col-xs-12">
                  <label class="myprofile_editcompany_txt editnameuk" for="com_reg">{{"ukprofile.regnolabel" | cxTranslate}}</label> <input class="myprofile_input form-control" id="com_reg" name="com_reg" value=""  formControlName="companyRegNumber">
                </div>
                <div class="col-md-3 col-sm-6 col-xs-12">
                  <label class="myprofile_editcompany_txt editnameuk" for="trading_since">{{"ukprofile.tradesincelabel" | cxTranslate}}</label> <input class="myprofile_input form-control" id="trading_since" name="trading_since" value=""  formControlName="tradingSince">
                </div>
              </div>
              <div class="row margin-T20">
                <div class="col-md-6 col-sm-6 col-xs-12">
                  <label class="myprofile_editbusinessinfo_txt">{{"accountinfo.businessinfolabel" | cxTranslate}}</label> <label class="myprofile_editbusinessinfo_txt_sub">{{"accountinfo.businessAddrlabel" | cxTranslate}}</label>
                </div>
              </div>
              <div class="row margin-T10">
                <div class="col-md-6 col-sm-6 col-xs-12">
                  <label class="myprofile_editcompany_txt" for="myprofile_Address1">{{"accountinfo.addrLine1" | cxTranslate}}</label>
                  <div class="input-group">
                    <input class="myprofile_state form-control" id="myprofile_Address1"
                      name="orgAddressForm.Line1" formControlName="orgAddressLine1" value="">
                    </div>
                    @if (getFormControl('orgAddressLine1').dirty && (getFormControl('orgAddressLine1').hasError('required'))) {
                      <span class="glyphicon glyphicon-exclamation-sign twofiled"></span>
                    }
                    @if (getFormControl('orgAddressLine1').dirty && (getFormControl('orgAddressLine1').hasError('required'))) {
                      <!-- <span class="glyphicon form-control-feedback glyphicon-exclamation-sign"></span> -->
                      <label id="myprofile_Address1-error" class="error help-block" for="myprofile_Address1">{{"accountinfo.ukaddrerrormsg" | cxTranslate}}</label>
                    }
                  </div>
                </div>
                <div class="row margin-T10">
                  <div class="col-md-6 col-sm-6 col-xs-12">
                    <label class="myprofile_editcompany_txt" for="myprofile_Address2">{{"accountinfo.addrLine2" | cxTranslate}}</label>
                    <input class="myprofile_state form-control" id="myprofile_Address2" value=""
                      name="orgAddressForm.line2" formControlName="orgAddressLine2">
                    </div>
                  </div>
                  <div class="row margin-T10">
                    <div class="col-md-6 col-sm-6 col-xs-12">
                      <label class="myprofile_editcompany_txt" for="myprofile_city">{{"accountinfo.city" | cxTranslate}}</label>
                      <div class="input-group">
                        <input class="myprofile_state form-control" id="myprofile_city"
                          name="orgAddressForm.city" formControlName="orgAddressCity" value="">
                        </div>
                        @if (getFormControl('orgAddressCity').dirty && getFormControl('orgAddressCity').hasError('required')) {
                          <span class="glyphicon glyphicon-exclamation-sign twofiled"></span>
                        }
                        @if (getFormControl('orgAddressCity').dirty && getFormControl('orgAddressCity').hasError('required')) {
                          <!-- <span class="glyphicon form-control-feedback glyphicon-exclamation-sign"></span> -->
                          @if (getFormControl('orgAddressCity').hasError('required')) {
                            <label id="myprofile_Address1-error" class="error help-block" for="myprofile_Address1">{{"accountinfo.cityerrormsg1" | cxTranslate}}</label>
                          }
                        }
                      </div>
                    </div>
                    <div class="row margin-T10 stateZip">
                      <div class="col-md-3 col-sm-6 col-xs-6">
                        <label class="myprofile_editcompany_txt" for="myprofile_state">{{"accountinfo.postcodelabel" | cxTranslate}}</label>
                        <input class="myprofile_state form-control" id="myprofile_post" name="orgAddressForm.postalCode" value="" formControlName="orgAddressZipCode">
                        @if (getFormControl('orgAddressZipCode').dirty && (getFormControl('orgAddressZipCode').hasError('required') || getFormControl('orgAddressZipCode').hasError('pattern'))) {
                          <span class="glyphicon glyphicon-exclamation-sign twofiled">
                          </span>
                        }
                        @if (getFormControl('orgAddressZipCode').dirty && (getFormControl('orgAddressZipCode').hasError('required') || getFormControl('orgAddressZipCode').hasError('pattern'))) {
                          <!-- <span class="glyphicon form-control-feedback glyphicon-exclamation-sign"></span> -->
                          @if (getFormControl('orgAddressZipCode').hasError('required')) {
                            <label id="myprofile_Address1-error" class="error help-block" for="myprofile_Address1">{{"accountinfo.postcodeerrormsg" | cxTranslate}}</label>
                          }
                          @if (getFormControl('orgAddressZipCode').hasError('pattern')) {
                            <label id="myprofile_Address1-error" class="error help-block" for="myprofile_Address1">{{"accountinfo.postcodeerrormsg" | cxTranslate}}</label>
                          }
                        }
                      </div>
                      <div class="col-md-3 col-sm-6 col-xs-6">
                        <label class="myprofile_editcompany_txt" for="myprofile_zipcode">{{"accountinfo.countrylabel" | cxTranslate}}</label>
                        <div class="input-group">
                          <input class="myprofile_state form-control myprofile_zipcode" id="myprofile_zipcode"
                            name="orgAddressForm.postalCode" value="" formControlName="orgAddressCountryName">
                            @if (getFormControl('orgAddressCountryName').dirty && (getFormControl('orgAddressCountryName').hasError('required') || getFormControl('orgAddressCountryName').hasError('pattern'))) {
                              <span class="glyphicon glyphicon-exclamation-sign">
                              </span>
                            }
                            @if (getFormControl('orgAddressCountryName').dirty && (getFormControl('orgAddressCountryName').hasError('required') || getFormControl('orgAddressCountryName').hasError('pattern'))) {
                              <!-- <span class="glyphicon form-control-feedback glyphicon-exclamation-sign"></span> -->
                              @if (getFormControl('orgAddressCountryName').hasError('required')) {
                                <label id="myprofile_Address1-error" class="error help-block" for="myprofile_Address1">{{"accountinfo.countryerrormsg" | cxTranslate}}</label>
                              }
                              @if (getFormControl('orgAddressCountryName').hasError('pattern')) {
                                <label id="myprofile_Address1-error" class="error help-block" for="myprofile_Address1">{{"accountinfo.countryerrormsg" | cxTranslate}}</label>
                              }
                            }
                          </div>
                        </div>
                      </div>
                      <div class="row margin-T10">
                        <div class="col-md-3 col-sm-6 col-xs-6">
                          <label class="myprofile_editbusinessinfo_txt_sub manage_top">{{"ukprofile.maincontactlabel" | cxTranslate}}</label>
                        </div>
                      </div>
                      <div class="row margin-T10">
                        <div class="col-md-6 col-sm-6 col-xs-12">
                          <label class="myprofile_editcompany_txt editnameuk" for="contact-name">{{"ukprofile.firstname" | cxTranslate}}</label> <input class="myprofile_state form-control" id="contact-name" name="firstName" value="" formControlName="customerDataFirstName">
                          @if (getFormControl('customerDataFirstName').dirty && (getFormControl('customerDataFirstName').hasError('required') || getFormControl('customerDataFirstName').hasError('pattern'))) {
                            <span class="glyphicon glyphicon-exclamation-sign twofiled">
                            </span>
                          }
                          @if (getFormControl('customerDataFirstName').invalid && getFormControl('customerDataFirstName').dirty && (getFormControl('customerDataFirstName').hasError('required') || getFormControl('customerDataFirstName').hasError('pattern'))) {
                            <!-- <span class="glyphicon form-control-feedback glyphicon-exclamation-sign"></span> -->
                            @if (getFormControl('customerDataFirstName').hasError('required')) {
                              <label id="myprofile_Address1-error" class="error help-block" for="myprofile_Address1">{{"ukprofile.fnameerror1" | cxTranslate}}</label>
                            }
                            @if (getFormControl('customerDataFirstName').hasError('pattern')) {
                              <label id="myprofile_Address1-error" class="error help-block" for="myprofile_Address1">{{"ukprofile.fnameerror2" | cxTranslate}}</label>
                            }
                          }
                        </div>
                        <div class="col-md-6 col-sm-6 col-xs-12">
                          <label class="myprofile_editcompany_txt editnameuk" for="contact-last">{{"ukprofile.lastname" | cxTranslate}}</label> <input class="myprofile_state form-control" id="contact-last" name="lastName" value="" formControlName="customerDataLastName">
                          @if (getFormControl('customerDataLastName').dirty && (getFormControl('customerDataLastName').hasError('required') || getFormControl('customerDataLastName').hasError('pattern'))) {
                            <span class="glyphicon glyphicon-exclamation-sign twofiled">
                            </span>
                          }
                          @if (getFormControl('customerDataLastName').dirty && (getFormControl('customerDataLastName').hasError('required') || getFormControl('customerDataLastName').hasError('pattern'))) {
                            <!-- <span class="glyphicon form-control-feedback glyphicon-exclamation-sign"></span> -->
                            @if (getFormControl('customerDataLastName').hasError('required')) {
                              <label id="myprofile_Address1-error" class="error help-block" for="myprofile_Address1">{{"ukprofile.lnameerror1" | cxTranslate}}</label>
                            }
                            @if (getFormControl('customerDataLastName').hasError('pattern')) {
                              <label id="myprofile_Address1-error" class="error help-block" for="myprofile_Address1">{{"ukprofile.fnameerror2" | cxTranslate}}</label>
                            }
                          }
                        </div>
                      </div>
                      <div class="row margin-T10">
                        <div class="col-md-6 col-sm-6 col-xs-12">
                          <label class="myprofile_editcompany_txt editnameuk" for="contact-tittle">{{"ukprofile.jobtitle" | cxTranslate}}</label>
                          <!-- <input class="myprofile_state form-control" id="contact-tittle" name="orgAddressForm.jobTitle" value="" formControlName="customerDataJobTitle"> -->
                          <!-- job title change for feb  -->
                          <select id="contact-tittle" name="orgAddressForm.jobTitle" class="myprofile_state form-control" formControlName="customerDataJobTitle">
                            @for (job of jobTitles; track job) {
                              <option value="{{job}}">{{job}}</option>
                            }
                          </select>
                          @if (getFormControl('customerDataJobTitle').touched && getFormControl('customerDataJobTitle').hasError('required')) {
                            <span class="glyphicon glyphicon-exclamation-sign twofiled">
                            </span>
                          }
                          @if (getFormControl('customerDataJobTitle').hasError('required')) {
                            <label  id="myprofile_jobtitle-error" class="error help-block" for="myprofile_jobtitle">{{"ukprofile.joberror" | cxTranslate}}</label>
                          }
                        </div>
                        <div class="col-md-6 col-sm-6 col-xs-12">
                          <label class="myprofile_editcompany_txt editnameuk" for="contact-email">{{"ukprofile.email" | cxTranslate}}</label> <input class="myprofile_state form-control" id="contact-email" name="orgAddressForm.email" value="" formControlName="customerDataOrgAddressEmail">
                          @if (getFormControl('customerDataOrgAddressEmail').dirty && (getFormControl('customerDataOrgAddressEmail').hasError('required') || getFormControl('customerDataOrgAddressEmail').hasError('pattern'))) {
                            <span class="glyphicon glyphicon-exclamation-sign twofiled">
                            </span>
                          }
                          @if (getFormControl('customerDataOrgAddressEmail').dirty && (getFormControl('customerDataOrgAddressEmail').hasError('required') || getFormControl('customerDataOrgAddressEmail').hasError('pattern'))) {
                            <!-- <span class="glyphicon form-control-feedback glyphicon-exclamation-sign"></span> -->
                            @if (getFormControl('customerDataOrgAddressEmail').hasError('required')) {
                              <label  id="myprofile_Address1-error" class="error help-block" for="myprofile_Address1">{{"ukprofile.emailerror" | cxTranslate}}</label>
                            }
                            @if (getFormControl('customerDataOrgAddressEmail').hasError('pattern')) {
                              <label  id="myprofile_Address1-error" class="error help-block" for="myprofile_Address1">{{"ukprofile.emailerror" | cxTranslate}}</label>
                            }
                          }
                        </div>
                      </div>
                      <div class="row margin-T10">
                        <div class="col-md-4 col-sm-6 col-xs-12">
                          <label class="myprofile_editcompany_txt editnameuk" for="contact-phone">{{"ukprofile.phone" | cxTranslate}}</label> <input class="myprofile_state form-control" id="contact-phone" maxlength="11" name="phoneNumber" value="" formControlName="customerDataOrgAddressPhone" (keyup)="change()">
                          @if (getFormControl('customerDataOrgAddressPhone').dirty && (getFormControl('customerDataOrgAddressPhone').hasError('maxlength') || getFormControl('customerDataOrgAddressPhone').hasError('pattern') || getFormControl('customerDataOrgAddressPhone').hasError('required') || getFormControl('customerDataOrgAddressPhone').hasError('minlength'))) {
                            <span class="glyphicon glyphicon-exclamation-sign twofiled" >
                            </span>
                          }
                          @if (getFormControl('customerDataOrgAddressPhone').dirty && (getFormControl('customerDataOrgAddressPhone').hasError('required') || getFormControl('customerDataOrgAddressPhone').hasError('pattern') || getFormControl('customerDataOrgAddressPhone').hasError('minlength') || getFormControl('customerDataOrgAddressPhone').hasError('maxlength'))) {
                            <!-- <span class="glyphicon form-control-feedback glyphicon-exclamation-sign"></span> -->
                            @if (getFormControl('customerDataOrgAddressPhone').hasError('required')) {
                              <label id="myprofile_Address1-error" class="error help-block" for="myprofile_Address1">{{"ukprofile.phoneerror1" | cxTranslate}}</label>
                            }
                            @if (getFormControl('customerDataOrgAddressPhone').hasError('minlength')) {
                              <label id="myprofile_Address1-error" class="error help-block" for="myprofile_Address1">{{"ukprofile.phoneerror1" | cxTranslate}}</label>
                            }
                            @if (getFormControl('customerDataOrgAddressPhone').hasError('maxlength')) {
                              <label id="myprofile_Address1-error" class="error help-block" for="myprofile_Address1">{{"ukprofile.phoneerror1" | cxTranslate}}</label>
                            }
                            @if (getFormControl('customerDataOrgAddressPhone').hasError('pattern')) {
                              <label id="myprofile_Address1-error" class="error help-block" for="myprofile_Address1">{{"ukprofile.phoneerror2" | cxTranslate}}</label>
                            }
                          }
                        </div>
                        <div class="col-md-2 col-sm-6 col-xs-12">
                          <label class="myprofile_editcompany_txt editnameuk" for="contact-phoneext">{{"ukprofile.extlabel" | cxTranslate}}</label> <input class="myprofile_state form-control" id="contact-phoneext" maxlength="4" name="phoneExt" value="" formControlName="customerDataOrgAddressPhoneExt">
                          @if (getFormControl('customerDataOrgAddressPhoneExt').dirty && (getFormControl('customerDataOrgAddressPhoneExt').hasError('maxlength') || getFormControl('customerDataOrgAddressPhoneExt').hasError('pattern'))) {
                            <span class="glyphicon glyphicon-exclamation-sign twofiled">
                            </span>
                          }
                          @if (getFormControl('customerDataOrgAddressPhoneExt').dirty && (getFormControl('customerDataOrgAddressPhoneExt').hasError('maxlength') || getFormControl('customerDataOrgAddressPhoneExt').hasError('pattern'))) {
                            <!-- <span class="glyphicon form-control-feedback glyphicon-exclamation-sign"></span> -->
                            @if (getFormControl('customerDataOrgAddressPhoneExt').hasError('maxlength')) {
                              <label id="myprofile_Address1-error" class="error help-block" for="myprofile_Address1">{{"ukprofile.exterror" | cxTranslate}}</label>
                            }
                            @if (getFormControl('customerDataOrgAddressPhoneExt').hasError('pattern')) {
                              <label id="myprofile_Address1-error" class="error help-block" for="myprofile_Address1">{{"ukprofile.exterror" | cxTranslate}}</label>
                            }
                          }
                        </div>
                      </div>
                      <input type="hidden" name="orgAddressForm.addressId" value="SP0000376350">
                      <input type="hidden" name="orgAddressForm.modifiedQualifiers" value="" id="modifiedQualifiers"
                        modified-id="orgAddressForm.addressId">
                        <div class="row margin-T30">
                          <div class="col-md-5 col-sm-6 col-xs-12"> </div>
                          <div class="col-md-7 col-sm-6 col-xs-12">
                            <div class="col-md-6 col-sm-6 col-xs-6 no-padding">
                              <button (click)="showedit()" type="button" class="myprofile_cancel"
                              id="myprofile_cancel">{{"profile.cancellabel" | cxTranslate}}</button>
                            </div>
                            <div class="col-md-6 col-sm-6 col-xs-6 no-padding">
                              <button (click)="submitBusinessDetails()" type="button" class="myprofile_submit submituk" id="myprofile_submit">{{"profile.submitlabel" | cxTranslate}}</button>
                            </div>
                          </div>
                        </div>
                        <!-- request modal -->
                        @if (requestModal) {
                          <div class="modal fade" id="requestform" role="dialog">
                            <div class="modal-dialog">
                              <div class="modal-content">
                                <div class="modal-header">
                                  <h4 class="modal-title myprofile_modal_header" id="myModalLabel">{{"accountinfo.reqchangestext" | cxTranslate}}</h4>
                                  <div  class="myprofile_modalclose" data-bs-dismiss="modal" >×</div>
                                </div>
                                <div class="modal-body">
                                  <p class="myprofile_modalbody_txt" [innerHTML]="'ukprofile.updatemsg' | cxTranslate">
                                    <div class="row margin-T20">
                                      <div class="col-md-6 col-sm-6 col-xs-12">
                                        <label class="myprofile_editbusinessinfo_txt">{{"ukprofile.companydetail" | cxTranslate}}</label>
                                      </div>
                                    </div>
                                    <div class="row margin-T10">
                                      <div class="col-md-6 col-sm-6 col-xs-12">
                                        <label class="myprofile_editcompany_txt editnameuk" for="company-name">{{"ukprofile.currorgname" | cxTranslate}}</label>
                                        <div>
                                          <label class="myprofile_editmodalbusinessinfo_txt editnameuk">{{accountdata?.spCompanyName}}</label>
                                        </div>
                                      </div>
                                      <div class="col-md-6 col-sm-6 col-xs-12 has-feedback has-success">
                                        <label class="myprofile_editcompany_txt editnameuk" for="reg_company">{{"ukprofile.neworgname" | cxTranslate}}</label> <input class="myprofile_input form-control" id="reg_company" name="orgName" modified-id="reg_company_updated" aria-invalid="false" formControlName="orgName" (keyup)="requestcheck()">
                                        @if (getFormControl('orgName').dirty && getFormControl('orgName').hasError('pattern') ) {
                                          <span class="glyphicon glyphicon-exclamation-sign twofiled">
                                          </span>
                                        }
                                        @if (getFormControl('orgName').dirty && getFormControl('orgName').hasError('pattern')) {
                                          <!-- <span class="glyphicon form-control-feedback glyphicon-exclamation-sign"></span> -->
                                          @if (getFormControl('orgName').hasError('pattern')) {
                                            <label id="myprofile_Address1-error" class="error help-block" for="myprofile_Address1">Please enter only letters</label>
                                          }
                                        }
                                      </div>
                                    </div>
                                    <div class="row margin-T10">
                                      <div class="col-md-6 col-sm-6 col-xs-12">
                                        <label class="myprofile_editcompany_txt editnameuk" for="cur_org_type">{{"ukprofile.currorgtype" | cxTranslate}}</label>
                                        <div>
                                          <label class="myprofile_editmodalbusinessinfo_txt editnameuk">{{accountdata?.businessType}}</label>
                                        </div>
                                      </div>
                                      <div class="col-md-6 col-sm-6 col-xs-12 has-success">
                                        <label class="myprofile_editcompany_txt editnameuk" for="reg_org">{{"ukprofile.neworgtype" | cxTranslate}}</label> <select class="myprofile_input form-control" id="reg_org" name="orgAddressForm.groupOrganization" modified-id="reg_org_updated" aria-invalid="false" formControlName="orgtype"  (change)="requestcheck()">
                                        <option value="" selected="selected">Select</option>
                                        <option name="businessType" value="GENERAL_PRACTICE">GP Medical Practice</option>
                                        <option name="businessType" value="PHARMACY">Pharmacy</option>
                                        <option name="businessType" value="HOSPITAL_PUBLIC">Hospital - Public</option>
                                        <option name="businessType" value="HOSPITAL_PRIVATE">Hospital - Private</option>
                                        <option name="businessType" value="NURSING_HOMES">Nursing Homes</option>
                                        <option name="businessType" value="CORRECTIONAL_FACILITY">Correctional Facility</option>
                                        <option name="businessType" value="WHOLESALER">Wholesaler</option>
                                      </select>
                                    </div>
                                  </div>
                                  <div class="row margin-T10">
                                    <div class="col-md-6 col-sm-6 col-xs-12">
                                      <label class="myprofile_editcompany_txt editnameuk" for="cur_nhscode">{{"ukprofile.nhslabel" | cxTranslate}}</label>
                                      <div>
                                        <label class="myprofile_editmodalbusinessinfo_txt editnameuk"></label>
                                      </div>
                                    </div>
                                    <div class="col-md-6 col-sm-6 col-xs-12 feedback has-feedback has-success">
                                      <label class="myprofile_editcompany_txt editnameuk" for="reg_nhscode">{{"ukprofile.newnhslabel" | cxTranslate}}</label> <input class="myprofile_input form-control" [attr.maxlength]=nhsmaxlength id="reg_nhscode" [ngClass]="nhsvalidationgp || nhsvalidationpharma || nhsvalidationall?'highlighbox':''" name="orgAddressForm.nhsCode" modified-id="reg_nhscode_updated" aria-invalid="false" (keyup)="nhsvalidation($event);requestcheck()" formControlName="nhscode"  >
                                      @if (nhsvalidationgp || nhsvalidationpharma || nhsvalidationall) {
                                        <span class="glyphicon glyphicon-exclamation-sign twofiled">
                                        </span>
                                      }
                                      @if (nhsvalidationgp || nhsvalidationpharma || nhsvalidationall) {
                                        <!-- <span class="glyphicon form-control-feedback glyphicon-exclamation-sign"></span> -->
                                        @if (nhsvalidationgp) {
                                          <label id="myprofile_Address1-error" class="error help-block" for="myprofile_Address1">{{"ukprofile.nhserror1" | cxTranslate}}</label>
                                        }
                                        @if (nhsvalidationpharma) {
                                          <label id="myprofile_Address1-error" class="error help-block" for="myprofile_Address1">{{"ukprofile.nhserror2" | cxTranslate}}</label>
                                        }
                                        @if (nhsvalidationall) {
                                          <label id="myprofile_Address1-error" class="error help-block" for="myprofile_Address1">{{"ukprofile.nhserror3" | cxTranslate}}</label>
                                        }
                                      }
                                    </div>
                                  </div>
                                  <div class="row margin-T10">
                                    <div class="col-md-6 col-sm-6 col-xs-12 ">
                                      <label class="myprofile_editcompany_txt editnameuk" for="cur_vat">{{"ukprofile.vatlabel" | cxTranslate}}</label>
                                      <div>
                                        <label class="myprofile_editmodalbusinessinfo_txt editnameuk"></label>
                                      </div>
                                    </div>
                                    <div class="col-md-6 col-sm-6 col-xs-12 has-feedback has-success">
                                      <label class="myprofile_editcompany_txt editnameuk" for="reg_vat">{{"ukprofile.newvatlabel" | cxTranslate}}</label> <input class="myprofile_input form-control" id="reg_vat" name="orgAddressForm.vatNumber" formControlName="vatno"  (keyup)="requestcheck()">
                                      @if (getFormControl('vatno').dirty && (getFormControl('vatno').hasError('maxlength') || getFormControl('vatno').hasError('pattern'))) {
                                        <span class="glyphicon glyphicon-exclamation-sign twofiled">
                                        </span>
                                      }
                                      @if (getFormControl('vatno').dirty && (getFormControl('vatno').hasError('maxlength') || getFormControl('vatno').hasError('pattern'))) {
                                        <!-- <span class="glyphicon form-control-feedback glyphicon-exclamation-sign"></span> -->
                                        @if (getFormControl('vatno').hasError('maxlength')) {
                                          <label id="myprofile_Address1-error" class="error help-block" for="myprofile_Address1">{{"ukprofile.vaterror1" | cxTranslate}}</label>
                                        }
                                        @if (getFormControl('vatno').hasError('pattern')) {
                                          <label id="myprofile_Address1-error" class="error help-block" for="myprofile_Address1">{{"ukprofile.phoneerror2" | cxTranslate}}</label>
                                        }
                                      }
                                    </div>
                                  </div>
                                  <div class="row margin-T10">
                                    <div class="col-md-6 col-sm-6 col-xs-12">
                                      <label class="myprofile_editcompany_txt editnameuk" for="cur_regno">{{"ukprofile.regnolabel" | cxTranslate}}</label>
                                      <div>
                                        <label class="myprofile_editmodalbusinessinfo_txt editnameuk"></label>
                                      </div>
                                    </div>
                                    <div class="col-md-6 col-sm-6 col-xs-12 has-feedback has-success">
                                      <label class="myprofile_editcompany_txt editnameuk" for="reg_regno">{{"ukprofile.newregnolabel" | cxTranslate}}</label> <input class="myprofile_input form-control" maxlength="8" id="reg_regno" name="orgAddressForm.companyRegistration" aria-invalid="false" modified-id="reg_regno_updated" formControlName="companyRegistration"  (keyup)="requestcheck()">
                                      @if (getFormControl('companyRegistration').dirty && (getFormControl('companyRegistration').hasError('maxlength') || getFormControl('companyRegistration').hasError('pattern') || getFormControl('companyRegistration').hasError('minlength'))) {
                                        <span class="glyphicon glyphicon-exclamation-sign twofiled">
                                        </span>
                                      }
                                      @if (getFormControl('companyRegistration').dirty && (getFormControl('companyRegistration').hasError('maxlength') || getFormControl('companyRegistration').hasError('pattern') || getFormControl('companyRegistration').hasError('minlength') )) {
                                        <!-- <span class="glyphicon form-control-feedback glyphicon-exclamation-sign"></span> -->
                                        @if (getFormControl('companyRegistration').hasError('minlength')) {
                                          <label id="myprofile_Address1-error" class="error help-block" for="myprofile_Address1">{{"ukprofile.regnoerror1" | cxTranslate}}</label>
                                        }
                                        @if (getFormControl('companyRegistration').hasError('maxlength')) {
                                          <label id="myprofile_Address1-error" class="error help-block" for="myprofile_Address1">{{"ukprofile.regnoerror2" | cxTranslate}}</label>
                                        }
                                        @if (getFormControl('companyRegistration').hasError('pattern')) {
                                          <label id="myprofile_Address1-error" class="error help-block" for="myprofile_Address1">{{"ukprofile.phoneerror2" | cxTranslate}}</label>
                                        }
                                      }
                                    </div>
                                  </div>
                                </div>
                                <div class="modal-footer">
                                  <button type="button" (click)="requestsubmit()"class="btn btn-default myprofile_modalrequestbtn requestchangesuk" [ngClass]="requestbtn?'':'requestbtn_disable'"id="request_change" data-bs-dismiss="modal">{{"accountinfo.reqchangestext" | cxTranslate}}</button>
                                </div>
                              </div>
                            </div>
                          </div>
                        }
                      </form>
                    </div>
                  }
                </div>
              </div>


            </div>
          </div>


          <app-custom-manage-location class="ukmanagelocation"></app-custom-manage-location>
          @if (isSearchByProfile) {
            <div class="col-xs-12 col-sm-12 myaccountheader credits_invoiceheader">{{"ukprofile.accnetworktext" | cxTranslate}}</div>
          }
          @if (isSearchByProfile) {
            <div class="col-md-12 col-sm-12 col-xs-12 no-padding">
              <div class="myprofile_content_account locationsuk">
                <div class="col-md-6 col-sm-12 col-xs-12 myprofile_locationheader allaccount">{{"ukprofile.allaccountstext" | cxTranslate}}</div>
                <div class="col-md-6 col-sm-12 col-xs-12">
                  <div class="joinaccountbox">
                    <a [routerLink]="'/register/join-account'"><div class="myjoinaccountbtn">{{"ukprofile.linkacctext" | cxTranslate}}</div></a>
                  </div>
                </div>
                <div class="col-md-9 col-xs-12 accounttext" [innerHTML]="'ukprofile.unlinkmsg' | cxTranslate">
                </div>
                <div class="col-md-12 col-sm-12 col-xs-12 myprofile_selectoptions">
                  <div class="myprofile_Accountsearch">
                    <i class="myprofile_global_searchicon"></i> <input type="search" #search placeholder="Search for locations" id="myprofile_account_searchbox" (keyup)="accountapplyFilter($event)">
                  </div>
                </div>
                <div class="col-md-12 col-sm-12 col-xs-12 margin-T20">
                  <div class="row myprofilelocation myprofileuklocation unlinkaccounttable">
                    <table  class="account-table" mat-table [dataSource]="dataSource" matSort (matSortChange)="announceSortChange($event)">
                      <ng-container matColumnDef="locID">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header disableClear="true" sortActionDescription="Sort by number">
                          {{"ukprofile.accNumlabel" | cxTranslate}}
                        </th>
                        <td mat-cell *matCellDef="let element">{{element.locID}} </td>
                      </ng-container>
                      <ng-container matColumnDef="locname">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header disableClear="true" sortActionDescription="Sort by name">
                          {{"ukprofile.orgnamelabel" | cxTranslate}}
                        </th>
                        <td mat-cell *matCellDef="let element">{{element.locname}} </td>
                      </ng-container>
                      <ng-container matColumnDef="address">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header disableClear="true" sortActionDescription="Sort by name">
                          {{"ukprofile.addrlabel" | cxTranslate}}
                        </th>
                        <td mat-cell *matCellDef="let element">{{element.address}} </td>
                      </ng-container>
                      <ng-container matColumnDef="checked">
                        <th mat-header-cell *matHeaderCellDef  >
                        </th>
                        <td mat-cell  class="unlinkColumn" *matCellDef="let element" [ngClass]="element.checked=='true'?'nonClickable':'Clickable'" >@if (element.checked!='true') {
                          <span data-bs-toggle="modal" data-bs-target="#Unlinkpopup" (click)="unlinkaccount(element.locID)" >{{"ukprofile.unlinktext" | cxTranslate}}</span>
                          }@if (element.checked=='true') {
                          <span>{{"ukprofile.unlinktext" | cxTranslate}}</span>
                        }  </td>
                      </ng-container>
                      <tr mat-header-row *matHeaderRowDef="displayedColumnsuk;sticky: true"></tr>
                      <tr mat-row *matRowDef="let row; columns: displayedColumnsuk;">
                      </tr>
                    </table>
                    @if (ACCOUNTsearchResultEmpty) {
                      <div class="no-results-message">
                        {{"ukprofile.norecordstext" | cxTranslate}}
                      </div>
                    }
                  </div>
                </div>
              </div>
            </div>
          }
          <div class="modal fade" id="Unlinkpopup">
            <div class="modal-dialog">
              <div class="modal-content">


                <div class="modal-body">
                  @if (unlinkmessage) {
                    <h4 class="modal-title Unlink_popHeader col-xs-9 unlinkshow" >{{"ukprofile.unlinkqstn" | cxTranslate}}</h4>
                  }
                  @if (thankshow) {
                    <h4 class="modal-title Unlink_popHeader col-xs-9 " >{{"ukprofile.thankyoutext" | cxTranslate}}</h4>
                  }
                  @if (errorshow) {
                    <p class="Unlink_popSubHeader col-xs-9  unlinkerrortext">{{"ukprofile.unlinksorrymsg" | cxTranslate}}</p>
                  }
                  <div class="col-xs-3">
                    <span class="Unlink_popClose unlinkerrorclose" data-bs-dismiss="modal">×</span>
                  </div>
                  @if (unlinkmessage) {
                    <p class="Unlink_popSubHeader col-xs-12 unlinkshow">{{"ukprofile.relinkmsg" | cxTranslate}}</p>
                  }
                  @if (thankshow) {
                    <p class="Unlink_popSubHeader col-xs-12 ">{{"ukprofile.unlinkedmsg" | cxTranslate}}</p>
                  }

                  <div class="clearboth"></div>
                  <div class="Unlink_PopBtnParent">
                    @if (thankshow) {
                      <button class="Unlinkclosebtn" data-bs-dismiss="modal" >{{"ukprofile.closelabel" | cxTranslate}}</button>
                    }
                    @if (errorshow) {
                      <button class="Unlinkclosebtn" data-bs-dismiss="modal" >{{"ukprofile.closelabel" | cxTranslate}}</button>
                    }

                    @if (unlinkmessage) {
                      <button class="Unlink_popBackBtn unlinkshow" data-bs-dismiss="modal"  >{{"profile.cancellabel" | cxTranslate}}</button>
                    }
                    @if (unlinkmessage) {
                      <button class="Unlink_popContBtn unlinkshow" (click)="unlinkcontine()" >{{"ukprofile.unlinkacctext" | cxTranslate}}</button>
                    }

                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="modal fade" id="thanksModal" [ngClass]="thanksModal?'show':'hide'"  role="dialog" >
            <div class="modal-dialog">
              <div class="modal-content">
                <div class="modal-header">
                  <h4 class="modal-title myprofile_modal_header" id="myModalLabel">{{"ukprofile.thankyoutext" | cxTranslate}}</h4>
                  <button type="button" class="myprofile_modalclose" (click)="closemodal()" data-bs-dismiss="modal" aria-hidden="true">×</button>

                </div>
                <div class="modal-body">
                  <p class="myprofile_modalbody_txt">{{"ukprofile.requestmsg" | cxTranslate}}</p>
                </div>
                <div class="modal-footer">
                  <button type="button" class="btn btn-default myprofile_modalclosebtn" (click)="closemodal()" data-bs-dismiss="modal">{{"ukprofile.closelabel" | cxTranslate}}</button>

                </div>
              </div>
            </div>
          </div>
        </div>




